import SpecialInvitationForm from "./SpecialInvitationForm";

function CreateSpecialInvite() {
  return <SpecialInvitationForm />;
}

export default CreateSpecialInvite;
